<template>
  <v-dialog :value="open" width="474" persistent class="upload">
    <v-card>
      <v-card-title>Upload File</v-card-title>

      <v-card-text class="pa-3 upload__text">
        <div class="d-flex justify-start align-end">
          <div class="mr-3">
            <v-btn color="primary" @click="select">Choose File</v-btn>
            <input ref="uploader" type="file" class="d-none" @change="onFileChange"/>
          </div>

          <div>{{ file ? file.name : 'No file chosen'}}</div>
        </div>
      </v-card-text>

      <v-divider></v-divider>

      <v-card-actions class="d-flex justify-end align-center">
        <v-btn color="primary" :loading="isUploadLoading" :disabled="isUploadLoading" @click="upload">Upload</v-btn>
        <v-btn color="primary" outlined :disabled="isUploadLoading" @click="close">Close</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
  export default {
    props: {
      open: {
        type: Boolean,
        default: false,
      },

      isUploadLoading: {
        type: Boolean,
        default: false
      },
    },

    data() {
      return {
        file: null,
      }
    },

    methods: {
      select() {
        this.$refs.uploader.click();
      },

      onFileChange() {
        this.file = this.$refs.uploader.files[0];
      },

      upload() {
        this.$emit('upload', this.file);
      },

      reset() {
        this.$refs.uploader.value = null;
        this.file = null;
      },

      close() {
        this.reset();
        this.$emit('close', false);
      }
    }   
  }
</script>

<style lang="scss" scoped>
  .upload__text {
    height: 127px;
  }
</style>